import React, { useState } from 'react';
import './ContactForm.css';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        organization: '',
        contactPerson: '',
        message: '',
        consent: false,
    });

    const [formErrors, setFormErrors] = useState({});
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const directEmail = 'business.development@eupraxiaclinical.com';

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const validateForm = () => {
        const errors = {};

        if (!formData.name) errors.name = 'Name is required';
        if (!formData.email) errors.email = 'Email is required';
        if (!formData.contactPerson) errors.contactPerson = 'Please select an enquiry type';
        if (!formData.message) errors.message = 'Message is required';
        if (!formData.consent) errors.consent = 'You must agree before submitting';

        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = validateForm();

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await fetch('https://formspree.io/f/maqkplkq', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify({
                    name: formData.name,
                    email: formData.email,
                    organization: formData.organization,
                    enquiryType: formData.contactPerson,
                    message: formData.message,
                    consent: formData.consent,
                }),
            });

            if (response.ok) {
                setFormSubmitted(true);
                setFormErrors({});

                setFormData({
                    name: '',
                    email: '',
                    organization: '',
                    contactPerson: '',
                    message: '',
                    consent: false,
                });
            } else {
                setFormErrors({
                    submit: 'Something went wrong while submitting the enquiry. Please try again.',
                });
            }
        } catch (error) {
            console.error(error);
            setFormErrors({
                submit: 'Unable to submit the enquiry at this time. Please try again later.',
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="contact-form-container">
            {formSubmitted ? (
                <div className="contact-successCard">
                    <h2>Thank you for your message.</h2>
                    <p>Our team will review your enquiry and contact you shortly.</p>

                    <p className="contact-directEmailText">
                        You may also email us directly at{' '}
                        <a href={`mailto:${directEmail}`} className="contact-directEmailLink">
                            {directEmail}
                        </a>
                    </p>
                </div>
            ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="contact-formIntro">
                        <h2>How can we help?</h2>

                        <p>
                            Please share your details and our team will get back to you
                            regarding your enquiry.
                        </p>

                        <div className="contact-directEmailBox">
                            <span>Prefer to email us directly?</span>

                            <a href={`mailto:${directEmail}`} className="contact-directEmailLink">
                                {directEmail}
                            </a>
                        </div>
                    </div>

                    <div className="Contact_div">
                        <div className="form-left">
                            <div className="form-group">
                                <label htmlFor="name">Name</label>
                                <input
                                    id="name"
                                    type="text"
                                    name="name"
                                    placeholder="Enter your full name"
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                                {formErrors.name && <p className="error">{formErrors.name}</p>}
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    id="email"
                                    type="email"
                                    name="email"
                                    placeholder="Enter your email address"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                                {formErrors.email && <p className="error">{formErrors.email}</p>}
                            </div>

                            <div className="form-group">
                                <label htmlFor="organization">Organization</label>
                                <input
                                    id="organization"
                                    type="text"
                                    name="organization"
                                    placeholder="Enter organization name"
                                    value={formData.organization}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="contactPerson">Enquiry Type</label>
                                <select
                                    id="contactPerson"
                                    name="contactPerson"
                                    value={formData.contactPerson}
                                    onChange={handleChange}
                                >
                                    <option value="">Select enquiry type</option>
                                    <option value="support">Support</option>
                                    <option value="sales">Sales</option>
                                    <option value="general">General</option>
                                </select>
                                {formErrors.contactPerson && (
                                    <p className="error">{formErrors.contactPerson}</p>
                                )}
                            </div>
                        </div>

                        <div className="form-right">
                            <div className="form-group">
                                <label htmlFor="message">Message</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    placeholder="Write your message here"
                                    value={formData.message}
                                    onChange={handleChange}
                                    className="message_textbox"
                                />
                                {formErrors.message && <p className="error">{formErrors.message}</p>}
                            </div>

                            <div className="form-group consent-group">
                                <label className="consent-label">
                                    <input
                                        type="checkbox"
                                        name="consent"
                                        checked={formData.consent}
                                        onChange={handleChange}
                                    />
                                    <span className="policy_span">
                                        I consent to my personal data being processed in accordance
                                        with the Privacy Policy.
                                    </span>
                                </label>
                                {formErrors.consent && <p className="error">{formErrors.consent}</p>}
                            </div>

                            {formErrors.submit && (
                                <p className="error">{formErrors.submit}</p>
                            )}

                            <button type="submit" disabled={isSubmitting}>
                                {isSubmitting ? 'Submitting...' : 'Submit Enquiry'}
                            </button>
                        </div>
                    </div>
                </form>
            )}
        </div>
    );
};

export default ContactForm;